/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction, createAsyncThunk } from '@reduxjs/toolkit';

import { addErrorMessage } from '@ibm-watson/shared/modules/ia/store/messages/actions';
import { ApiStatus } from '../../../../../ts';
import { DataType } from '../../../../../ts/action';
import {
  CreateAsyncThunk,
  SystemDataTypesSlice
} from '../../../../../ts/state';
import * as API from '../../../api/data-types';
import { entityAdapter } from '../adapter';

export const listSystemDataTypes = createAsyncThunk<
  DataType[],
  unknown,
  CreateAsyncThunk
>(
  'system-data-types/list',
  async (params = {}, { dispatch }) => {
    try {
      const response = await API.listSystemDataTypes(params);
      return response || [];
    } catch (error) {
      dispatch(addErrorMessage(error));
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const { systemDataTypes } = getState();
      return systemDataTypes.listStatus !== ApiStatus.LOADING;
    }
  }
);
const reducer = {
  [listSystemDataTypes.pending.toString()]: (
    state: SystemDataTypesSlice,
    _action: AnyAction
  ) => {
    state.listStatus = ApiStatus.LOADING;
    state.listError = null;
  },
  [listSystemDataTypes.fulfilled.toString()]: (
    state: SystemDataTypesSlice,
    action: AnyAction
  ) => {
    state.listStatus = ApiStatus.SUCCEEDED;
    state.listError = null;
    state.listFetched = Date.now();
    entityAdapter.setAll(state, action.payload);
  },
  [listSystemDataTypes.rejected.toString()]: (
    state: SystemDataTypesSlice,
    action: AnyAction
  ) => {
    state.listStatus = ApiStatus.ERROR;
    state.listError = action.error;
  }
};
export default reducer;
